import * as React from "react";
import { ReactPaginate } from "@/lib/cjs-interop";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null;
  }

  const handlePageClick = (event: { selected: number }) => {
    const newPage = event.selected + 1; // React Paginate uses zero-based index
    onPageChange(newPage);
  };

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel="&raquo;"
      previousLabel="&laquo;"
      containerClassName="mt-4 flex justify-center"
      onPageChange={handlePageClick}
      forcePage={currentPage - 1}
      pageRangeDisplayed={5}
      pageCount={totalPages}
      renderOnZeroPageCount={null}
      breakLinkClassName="mx-1 px-3"
      previousLinkClassName="mx-1 px-3 py-1 bg-white border border-gray-400 text-gray-700 hover:bg-gray-300 rounded"
      nextLinkClassName="mx-1 px-3 py-1 bg-white border border-gray-400 text-gray-700 hover:bg-gray-300 rounded"
      pageLinkClassName="mx-1 px-3 py-1 bg-white border border-gray-400 text-gray-700 hover:bg-gray-300 rounded"
      activeLinkClassName="!bg-primary text-white"
    />
  );
};
